import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import apiService from './api.service';
import { UrlList, replaceParamVal } from './accountSetting.api';
export var getSolutionsApi = function getSolutionsApi() {
  return apiService.get(UrlList.solutionUrls.getSolutions, {}, {
    catchError: true
  }).then(function (res) {
    var data = res.data;
    return formatSolutionsRole(data);
  });
};

function formatSolutionsRole(data) {
  var result = {
    solutionList: [],
    solutionToRoles: {},
    roleToSubscriptions: {}
  };
  if (!Array.isArray(data)) return result;
  result = data.reduce(function (acc, sol) {
    var solID = sol.id;
    var hasSubscription = sol.additionalInfos ? !!sol.additionalInfos.find(function (i) {
      return i.value === 'User';
    }) : false;
    acc.solutionList.push({
      id: solID,
      name: sol.fullName || sol.name,
      hasSubscription: hasSubscription
    });
    acc.solutionToRoles[solID] = sol.roles.map(function (role) {
      return {
        id: role.id,
        name: role.displayName || role.name
      };
    });
    sol.roles.forEach(function (role) {
      var roleID = role.id;
      acc.roleToSubscriptions[roleID] = Array.isArray(role.userSubscriptions) ? role.userSubscriptions.filter(function (s) {
        return s.licenseType === 'User' && !s.licensedObjectID;
      }).map(function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          id: s.objectID,
          name: s.objectID
        });
      }) : [];
    });
    return acc;
  }, result);
  return result;
}

export var getSolutionsInfoApi = function getSolutionsInfoApi() {
  return apiService.get(UrlList.solutionUrls.getSolutionsAttachedInfo, {}, {
    catchError: true
  }).then(function (res) {
    var data = res.data;
    return formatSolutions(data);
  });
};

function formatSolutions(data) {
  if (!Array.isArray(data)) return [];
  return data.map(function (sol) {
    return _objectSpread(_objectSpread({}, sol), {}, {
      name: sol.fullName || sol.name,
      hasSubscription: sol.roles && !!sol.roles.map(function (role) {
        return role.userSubscriptions;
      })[0]
    });
  });
}

export var getSolutionUsersApi = function getSolutionUsersApi(params) {
  var solutionId = params.solutionId,
      pageSize = params.pageSize,
      pageIndex = params.pageIndex,
      _params$orderBy = params.orderBy,
      orderBy = _params$orderBy === void 0 ? 'UserName' : _params$orderBy,
      _params$orderDirectio = params.orderDirection,
      orderDirection = _params$orderDirectio === void 0 ? 'asc' : _params$orderDirectio;
  return apiService.get(replaceParamVal(UrlList.solutionUrls.getSolutionUsers, {
    solutionId: solutionId,
    pageSize: pageSize,
    pageIndex: pageIndex,
    orderBy: orderBy,
    orderDirection: orderDirection
  }), {}, {
    catchError: true
  }).then(function (res) {
    var data = res.data;
    return formatSolutionUser(solutionId, data);
  });
};

function formatSolutionUser(solutionId, data) {
  var result = Array.isArray(data.rows) ? data.rows.map(function (item) {
    return {
      Id: item.id,
      LastName: item.surname,
      FirstName: item.givenName,
      Email: item.email,
      AvatarUrl: item.avatarUrl,
      LastAccessTime: item.lastAccess && item.lastAccess.lastAccessDate,
      Roles: item.assignedSolutions.filter(function (item) {
        return item.id === solutionId;
      }).map(function (item) {
        return item.roles.map(function (v) {
          return {
            id: v.id,
            displayName: v.displayName || v.name,
            name: v.displayName || v.name
          };
        });
      })[0] || [],
      Subscriptions: item.assignedSolutions.filter(function (item) {
        return item.id === solutionId;
      }).map(function (item) {
        var _item$roles$map = item.roles.map(function (v) {
          return v.userSubscriptions ? v.userSubscriptions[0] : '';
        }),
            _item$roles$map2 = _slicedToArray(_item$roles$map, 1),
            obj = _item$roles$map2[0];

        return obj ? _objectSpread(_objectSpread({}, obj), {}, {
          id: obj.objectID,
          name: "".concat(obj.objectID, " ").concat(obj.licenseTier.toUpperCase(), " ").concat(obj.expiryDate.split('T')[0]),
          value: obj.objectID
        }) : '';
      })[0] || '',
      AssignedSfxRole: item.assignedSfxRoles
    };
  }) : [];
  return {
    userList: result,
    totalNum: data.total
  };
}

export var getSolutionNoAccessUsersApi = function getSolutionNoAccessUsersApi(solutionId) {
  return apiService.get(replaceParamVal(UrlList.solutionUrls.getSolutionNoAccessUsers, {
    solutionId: solutionId
  }), {}, {
    catchError: true
  }).then(function (res) {
    var data = res.data;
    return formatSolutionNoAccessUsers(data);
  });
};

function formatSolutionNoAccessUsers(data) {
  if (!Array.isArray(data)) return [];
  return data.map(function (item) {
    return {
      id: item.id,
      lastName: item.surname,
      firstName: item.givenName,
      email: item.email,
      name: item.email
    };
  });
}

export var assignUserApi = function assignUserApi(data, option) {
  return apiService.put(UrlList.solutionUrls.assignUserToSolution, data, option);
};
export var removeUserApi = function removeUserApi(data, option) {
  return apiService.put(UrlList.solutionUrls.removeUserFromSolution, data, option);
};
export var updateUserApi = function updateUserApi(data, option) {
  return apiService.put(UrlList.solutionUrls.updateUserFromSolution, data, option);
};